/* Détection « téléphone mobile » pour restreindre la page passager /scan.
   On s'appuie d'abord sur navigator.userAgentData.mobile (précis sur Chromium :
   true uniquement pour les téléphones, false pour tablettes/desktop), sinon on
   retombe sur l'User-Agent. Les tablettes ne sont PAS considérées comme des
   téléphones (la page est un parcours passager conçu pour smartphone). */
export function isMobilePhone() {
  if (typeof navigator === "undefined") return true; // pas de navigator → on n'empêche pas

  const uaData = navigator.userAgentData;
  if (uaData && typeof uaData.mobile === "boolean") return uaData.mobile;

  const ua = navigator.userAgent || "";
  // Tablettes explicitement exclues (Android sans « Mobile », iPad, etc.)
  const isTablet = /iPad|Tablet|PlayBook|Silk|Kindle|(Android(?!.*Mobile))/i.test(ua);
  if (isTablet) return false;

  return /Mobi|iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|BB10|Opera Mini|IEMobile/i.test(ua);
}
